import React, { useContext, useState } from "react";
import { ProfileContext } from "./ProfileContext";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { PROFILE_UPLOAD_STATUS_GETUPLOADDATA_FAILED, PROFILE_UPLOAD_STATUS_UPLOAD_FAILED, PROFILE_UPLOAD_STATUS_UPLOADED } from "../../constants/Constants";
import useAuth from "../../hooks/useAuth";
import { Checkbox, FormControlLabel, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { RenderTncContent } from "../../acknowledgements/RenderTncContent";

const renderField = (label, value) => {
  return value ? (
    <ListItem>
      <ListItemText primary={label} secondary={value} />
    </ListItem>
  ) : <ListItem>
        <ListItemText primary={label} secondary={"Not Filled"} />
      </ListItem>;
};

function Confirm() {
  const {
    firstName,
    lastName,
    dateOfBirth,
    gender,
    city,
    state,
    country,
    pin,
    occupation,
    qualification,
    annualIncome,
    employedIn,
    caste,
    isNRI,
    maritalStatus,
    motherTongue,
    bloodGroup,
    heightFeet,
    heightInch,
    weight,
    foodHabits,
    bio,
    localProfileImageUrls,
    profileImageUploadStatuses,
    languagesKnown,
    gotra,
    nakshatra,
    rashi,
    kuldevta,
    fatherName,
    motherName,
    fatherNumber,
    motherNumber,
    drinkHabits,
    smokeHabits,
    userPreferences,
    math,
    tncAckCheckedDuringProfile,
    setTncAckCheckedDuringProfile,
    declarationAckCheckedDuringProfile,
    setDeclarationAckCheckedDuringProfile,
  } = useContext(ProfileContext);

  const {
    shouldUserSignTnc,
    shouldUserProvideDeclaration
  } = useAuth();

  var shouldRenderAckSetion = shouldUserProvideDeclaration || shouldUserSignTnc
  const [tncModalOpen, setTncModalOpen] = useState(false);

  return (
    <>
      <center>
        <h3 className="profile-header">
          <Typography variant="h6" gutterBottom>
            Confirm Your Details
          </Typography>
        </h3>
      </center>
      <div className="m-2">
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <List>
              {renderField("First Name", firstName)}
              {renderField("Last Name", lastName)}
              {renderField("Date of Birth", dateOfBirth)}
              {renderField("Gender", gender)}
              {renderField("City", city)}
              {renderField("State", state)}
              {renderField("Country", country)}
              {renderField("Postal Code", pin)}
              {renderField("Occupation", occupation)}
            </List>
          </Grid>
          <Grid item xs={12} sm={4}>
            <List>
              {renderField("Qualification", qualification.toString())}
              {renderField("Annual Income", annualIncome)}
              {renderField("Employed In", employedIn)}
              {renderField("Caste", caste)}
              {renderField("Gotra", gotra)}
              {renderField("Nakshatra", nakshatra)}
              {renderField("Rashi", rashi)}
              {renderField("Kuldevta", kuldevta)}
              {renderField("NRI Status", isNRI ? "Yes" : "No")}
              {renderField("Marital Status", maritalStatus)}
              {renderField("Math", math)}
            </List>
          </Grid>
          <Grid item xs={12} sm={4}>
            <List>
              {renderField("Mother Tongue", motherTongue)}
              {renderField("Languages Known", languagesKnown.toString())}
              {renderField("Blood Group", bloodGroup)}
              {renderField("Height", `${heightFeet} feet, ${heightInch} inches`)}
              {renderField("Weight", `${weight} kg`)}
              {renderField("Food Habits", foodHabits)}
              {renderField("Drinking Habits", drinkHabits)}
              {renderField("Smoking Habits", smokeHabits)}
              {renderField("Father's Name", fatherName)}
              {renderField("Father's Number", fatherNumber)}
              {renderField("Mother's Name", motherName)}
              {renderField("Mother's Number", motherNumber)}
            </List>
          </Grid>
          <Grid item xs={12} sm={6}>
            <List>
              <ListItem>
                <div>
                  <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                    Bio
                  </Typography>
                  <Typography gutterBottom>{bio || "Not Provided"}</Typography>
                </div>
              </ListItem>
              <ListItem>
                <div>
                  <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                    Partner Preferences
                  </Typography>
                  <Typography gutterBottom>{userPreferences || "Not Provided"}</Typography>
                </div>
              </ListItem>
            </List>
          </Grid>
        </Grid>
        
        {shouldRenderAckSetion && <Grid item xs={12} sm={12}>
          <Typography variant="h6" gutterBottom>
            Acknowledgements
          </Typography>

          {shouldUserSignTnc && (
            <>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tncAckCheckedDuringProfile}
                    onChange={() => setTncModalOpen(true)} // Instead of ticking directly, open the modal
                    color="primary"
                  />
                }
                label={(
                  <> I have read and understood the {' '}
                  <span style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}>
                    Terms and Conditions
                  </span>
                  </>               
                )}
              />
        
              <Dialog open={tncModalOpen} onClose={() => setTncModalOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Terms and Conditions</DialogTitle>
                <DialogContent dividers>
                  <RenderTncContent />
                </DialogContent>
                <DialogActions>
                  <Button 
                    onClick={() => {
                      setTncAckCheckedDuringProfile(false);
                      setTncModalOpen(false);
                    }} 
                    color="secondary">
                    Cancel
                  </Button>
                  <Button 
                    onClick={() => {
                      setTncAckCheckedDuringProfile(true);
                      setTncModalOpen(false);
                    }} 
                    variant="contained" 
                    color="primary"
                  >
                    I Accept
                  </Button>
                </DialogActions>
              </Dialog>
            </>
          )}

          {shouldUserProvideDeclaration && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={declarationAckCheckedDuringProfile}
                  onChange={() => setDeclarationAckCheckedDuringProfile(!declarationAckCheckedDuringProfile)}
                  color="primary"
                />
              }
              label="I confirm that the information I have submitted is true and accurate"
            />
          )}

        </Grid>}
        <Grid container spacing={3} className="mt-4">
          <Grid item xs={12} sm={12}>
            <List>
              <ListItem>
                <div>
                  <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                    Photographs
                  </Typography>
                  <Grid container spacing={2} justifyContent="flex-start">
                    {localProfileImageUrls.map((url, index) => (
                      profileImageUploadStatuses[index] === PROFILE_UPLOAD_STATUS_UPLOADED && (
                        <Grid item xs={12} sm={4} key={index}>
                          <div
                            style={{
                              width: '100%',
                              aspectRatio: '3/4',
                              position: 'relative',
                              overflow: 'hidden',
                              borderRadius: 12,
                              border: '1px solid #ddd',
                              background: '#f8f8f8',
                            }}
                          >
                            <img
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                display: 'block',
                              }}
                              src={url}
                              alt={`${firstName} ${lastName} profile pic ${index + 1}`}
                            />
                          </div>
                        </Grid>
                      )
                    ))}
                  </Grid>
                  {profileImageUploadStatuses.some(status => 
                    status === PROFILE_UPLOAD_STATUS_UPLOAD_FAILED || 
                    status === PROFILE_UPLOAD_STATUS_GETUPLOADDATA_FAILED
                  ) && (
                    <Typography variant="body1" sx={{ width: "100%", color: "red", mt: 2 }}>
                      Some image uploads failed. Please retry after completing profile.
                    </Typography>
                  )}
                </div>
              </ListItem>
            </List>
          </Grid>
        </Grid>

      </div>
    </>
  );
}

export default Confirm;
